const SUPPORTED_LANGUAGES = ['en', 'ar'];
const FALLBACK_LANGUAGE = 'en';
const RTL_LANGUAGES = ['ar'];

const normalizeLanguage = (language) => {
    const normalized = typeof language === 'string' ? language.toLowerCase() : FALLBACK_LANGUAGE;
    return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : FALLBACK_LANGUAGE;
};

/**
 * Synchronizes <html lang> and <html dir> with the given application language.
 * Centralized so all callers stay in sync.
 *
 * @param {string} language
 * @returns {{ lang: string, dir: 'rtl'|'ltr' }}
 */
const applyDocumentLanguage = (language) => {
    const normalizedLanguage = normalizeLanguage(language);
    const direction = RTL_LANGUAGES.includes(normalizedLanguage) ? 'rtl' : 'ltr';

    if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.lang = normalizedLanguage;
        document.documentElement.dir = direction;
    }

    return { lang: normalizedLanguage, dir: direction };
};

export { normalizeLanguage, SUPPORTED_LANGUAGES, FALLBACK_LANGUAGE };
export default applyDocumentLanguage;
